import { useMutation } from '@apollo/client/react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { ILanguage, UpdateOrganisationDocument } from 'graphql/types';
import { ApolloError } from 'common/components/ApolloError';
import { CoverPage } from 'hydra/pages/CoverPage';
import { PageTitle } from 'common/components/PageTitle';
import { Typography } from 'common/components/Typography';
import { Text } from 'common/components/Text';
import { OrganisationLanguageForm } from 'organisation/components/forms/OrganisationLanguageForm';
import { getUrl } from 'route/utils/getUrl';
import { OrganisationOnboardingLottie } from 'organisation/components/OrganisationOnboardingLottie';
import { OrganisationOnboardingNavigation } from 'organisation/components/OrganisationOnboardingNavigation';

export const OrganisationLanguagePage = () => {
    const [translate, i18n] = useTranslation();
    const navigate = useNavigate();

    const [updateOrganisation, { error: updateError }] = useMutation(
        UpdateOrganisationDocument
    );

    return (
        <>
            {updateError && <ApolloError error={updateError} />}
            <CoverPage
                footer={<OrganisationOnboardingNavigation />}
                secondaryContent={<OrganisationOnboardingLottie />}
            >
                <PageTitle>
                    {translate('orgLanguagePage.browserTitle')}
                </PageTitle>

                <Box sx={{ mb: 2 }}>
                    <Typography variant="h2">
                        {translate('orgLanguagePage.title')}
                    </Typography>
                </Box>

                <Text>{translate('orgLanguagePage.content')}</Text>

                <OrganisationLanguageForm
                    initialValues={{ language: i18n.language as ILanguage }}
                    onChangeLanguage={(value) => {
                        i18n.changeLanguage(value);
                    }}
                    onSubmit={async (value) => {
                        if (!value.language) return;

                        await updateOrganisation({
                            variables: {
                                organisation: { language: value.language },
                            },
                        });

                        // Redirect to Organisation Images when language has been updated
                        navigate(getUrl('ORGANISATION_IMAGES'));

                        return;
                    }}
                />
            </CoverPage>
        </>
    );
};
